import { RootState } from "@/store/store";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";

export const budgetDetailsStartDateSelector = (state: RootState) => {
  return budgetDetailsByIdDataSelector(state)?.start_date;
};
